import { render, staticRenderFns } from "./ParentField.vue?vue&type=template&id=ce1e38e6&"
import script from "./ParentField.vue?vue&type=script&lang=js&"
export * from "./ParentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseField: require('/app/components/fields/BaseField.vue').default})
